// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon-loading[data-v-5e4af00a] {\n  padding: 10px 0;\n}\n.icon-loading p[data-v-5e4af00a] {\n  text-align: center;\n  font-size: 14px;\n  margin-top: 5px;\n}\n.icon-loading--white[data-v-5e4af00a] {\n  color: #fff;\n}\n.icon-loading--blue[data-v-5e4af00a] {\n  color: #46aad5;\n}\n", ""]);
// Exports
module.exports = exports;
